import configChains from "../config-chains.json";

export default class CommonHelper {
  formatPrice(input, precision) {
    let price = input.toString();
    if (price.length > precision) return price.substring(0, precision);

    return price;
  }

  getChainConfig(chainId) {
    var chain = configChains[chainId];
    if (!chain) throw new Error("Invalid chain");

    console.log(chain);
    return chain;
  }

  getAllChainConfigs() {
    return configChains;
  }

  getIcon(event_type) {
    {
      switch (event_type) {
        case "Sell":
          return "shopping_cart";

        case "List":
          return "local_offer_outlined";

        case "Minted":
          return "auto_awesome";
      }
    }
  }
}
